export default "__VITE_ASSET__DgIm9gTf__"